import { render, staticRenderFns } from "./SitePageResultsGrid.vue?vue&type=template&id=018c81fb&"
import script from "./SitePageResultsGrid.vue?vue&type=script&lang=js&"
export * from "./SitePageResultsGrid.vue?vue&type=script&lang=js&"
import style0 from "./SitePageResultsGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports